import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdResource } from "../../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
import { selectRecipeProductionSkipCost } from "../../../../selectors/selectRecipeInfo";
import { actionBeginBuyWithGoldProcess } from "../../../buy-with-gold/actionBuyWithGold";
import { actionOngoingPurchasePremiumDeselect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { actionBuildingsDeselect } from "../../../player-base/buildings/actionBuildings";
import { actionProductionSkipConfirmed, TypeActionProductionInfo } from "../actionProductionInfo";
export var epicProductionSkip = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.Skip), switchMap(function (action) {
        var state = state$.value;
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold).amount || Long.ZERO;
        var goldAmount = selectRecipeProductionSkipCost(state, action.building);
        var onConfirm = actionProductionSkipConfirmed(action.building);
        return of(actionBeginBuyWithGoldProcess(playerGoldInfo, goldAmount, onConfirm, actionOngoingPurchasePremiumDeselect(), undefined, undefined, actionBuildingsDeselect()));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/epics/epicProductionSkip.ts
// module id = 1939
// module chunks = 3